import "./InputBalloon.css.ts.vanilla.css.mjs";
var _ = "p295__InputBalloon-518a_fc9709577__139xo4o0", a = "p295__InputBalloon-518a_fc9709577__139xo4o2", l = "p295__InputBalloon-518a_fc9709577__139xo4o1";
export {
  _ as balloon,
  a as balloonContent,
  l as overlay
};
//# sourceMappingURL=InputBalloon.css.mjs.map
